import { postLogger } from '../redux/Slice/loggerSlice';
import { MetricaBuilder } from '@claro/mimo-front-logger';

export const sendLogger = (dispatch, message, type) => {
  const parameters = '';

  const details = MetricaBuilder.new().withDetail(parameters).build();

  const body = {
    level: type,
    message: message,
    details: details?.details,
  };

  dispatch(postLogger(body));
};
